module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"values":"Werte"},"en":{"values":"Values"}}')
  delete Component.options._Ctor
}
